import React from "react";
import CategoryPage from "./CategoryPage";

export default function LabEquipmentPage() {
  return (
    <CategoryPage
      categoryMatch="lab equipment"
      title="Lab Equipment & Consumables"
      subtitle="Precision instruments, glassware, reagents, and consumables for laboratory and research work."
      searchPlaceholder="Search lab equipment..."
    />
  );
}